/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CustomFieldStorePathParams,
	CustomFieldStoreRequest,
	CustomFieldStoreResponse,
} from '../types/CustomFieldStore'

/**
 * POST /:organisation/custom_fields
 * @see backend/nexus/modules/CustomField/Http/Controllers/CustomFieldController.php CustomFieldController::store
 */
export async function customFieldStore(
	organisation: CustomFieldStorePathParams['organisation'],
	data: CustomFieldStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CustomFieldStoreResponse>> {
	return axiosInstance.post(`/${organisation}/custom_fields`, data, config)
}
